import React from "react";

import moment from "moment";
import DatePicker from "react-datepicker";
// import "../../../../../styles/scss/_vendor/react-datepicker.min.css";

import { FormInput } from "./FormInput";

import { func_validation } from "functions";



/* Props 
 * {
 *      // Label
 *      isInputOptional: false,
 *      isLabelOptional: false,
 *      inputLabel: "", 
 *      inputSideLabel: "", 
 * 
 *      // Input
 *      inputValue: "",
 *      inputDateFormat: "",
 * 
 *      // Input Options
 *      datePickerOptions: {},
 *      inputPlaceholder: "",
 *      isInputDisabled: false, 
 * 
 *      // Input Handling
 *      isInputFocusHandlingRequired: false,
 *      isInputBlurHandlingRequired: false,
 * 
 *      // Custom Input Validation
 *      customValidator_onChange: (date, value_formatted)=>{ return value; },
 *      isValuePropagationGuarded_onChange: (date, value_formatted)=>{ return true/false; },
 * 
 *      // Input Propagation
 *      inputStateName: undefined,
 *      propagateValueChange: (inputStateName, value_formatted)=>{},
 *      handleInputChangeExtend: (date, value_formatted)=>{},
 *      handleInputFocusExtend: (e)=>{},
 *      handleInputBlurExtend: ()=>{},
 * 
 *      // Error Display
 *      isErrorOptional: false,
 *      isFormSubmissionAttempted: false,
 * 
 *      // Error Checking
 *      customErrorMsgDefault: "",
 *      customErrorValidation: undefined,
 *      customErrorMsg: "",
 * 
 *      // Custom Error
 *      isInputHasError: false,
 *      customErrorDisplayArray: [{ isError: true|false, errorMsg: "" }],
 * 
 *      // Others
 *      className: "",
 *      customInputClassName: "",
 *      formInputCustomTheme: "component-formInputTheme_default",
 *      isMarginBtmOptional: false,
 *      inputCustomOptions: {},
 * }
 */

class FormInput_datePresentation extends React.Component {
	constructor(props) {
		super(props);
        this.state = {
            currentDate: "",
            datePickerDateStore: null,

            dateFormat: func_validation.getObjectPropertyValue(props, "inputDateFormat", "YYYY-MM-DD"),
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputFocus = this.handleInputFocus.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);

        this._updateCurrentDateFromParent = this._updateCurrentDateFromParent.bind(this);
        this._formatDatePickerDate = this._formatDatePickerDate.bind(this);
    }

	componentDidMount() {
        this._updateCurrentDateFromParent();
	}
	
    componentDidUpdate() {
        this._updateCurrentDateFromParent();
    }
    
    handleInputChange(date) {
        const { inputStateName } = this.props;
        
        // Value
        let value_formatted = this._formatDatePickerDate(date);
        this.setState({ datePickerDateStore: date });

        // Custom Validator
        if (this.props.customValidator_onChange) value_formatted = this.props.customValidator_onChange(date, value_formatted);

        // Update parent state
        if (this.props.propagateValueChange) {
            if (this.props.isValuePropagationGuarded_onChange) {
                if (this.props.isValuePropagationGuarded_onChange(date, value_formatted)) {
                    this.props.propagateValueChange(inputStateName, value_formatted); 
                    this.setState({ currentDate: value_formatted });
                }
            }
            else {
                this.props.propagateValueChange(inputStateName, value_formatted);
                this.setState({ currentDate: value_formatted });
            }
        }
        
        // Extension
        if (this.props.handleInputChangeExtend) this.props.handleInputChangeExtend(date, value_formatted);
    }

    handleInputFocus(e) {
        // Extension
        if (this.props.handleInputFocusExtend) this.props.handleInputFocusExtend(e);
    }

    handleInputBlur() {
        // Extension
        if (this.props.handleInputBlurExtend) this.props.handleInputBlurExtend();
    }
    
    _updateCurrentDateFromParent() {
        const { inputValue } = this.props;
        const { currentDate, dateFormat } = this.state;
        
        if (inputValue !== currentDate) {
            let inputValue_formatted = moment(inputValue, dateFormat);
            if (inputValue_formatted.isValid()) {
                this.setState({ currentDate: inputValue, 
                                datePickerDateStore: inputValue_formatted });
            }
        }
    }

    _formatDatePickerDate(date) {
        const { dateFormat } = this.state;
        
        let currentMoment = moment(date);
        if (currentMoment.isValid()) return moment(date).format(dateFormat);
        return "";
    }

    render() {
        const { className, customInputClassName, formInputCustomTheme, isMarginBtmOptional, inputCustomOptions, 
                // Label
                isLabelOptional, inputLabel, inputSideLabel, isInputOptional, 
                // Input
                inputValue, //inputDateFormat, 
                datePickerOptions, inputPlaceholder, isInputDisabled,
                // Input Handling
                isInputFocusHandlingRequired, isInputBlurHandlingRequired, 
                // Error Checking
                isErrorOptional, 
                isFormSubmissionAttempted, 
                customErrorMsgDefault, customErrorValidation, customErrorMsg,
                isInputHasError, customErrorDisplayArray } = this.props;
        
        const { datePickerDateStore, dateFormat } = this.state;
        
        // Label
        let inputLabelDisplay = (
            <span className="component-formInput-label">
                {inputLabel}
                {(isInputOptional)?"":(<span className="component-formInput-labelAsterisk">*</span>)}
            </span>
        );

        // SideLabel
        let inputSideLabelDisplay = (
            <span className="component-formInput-sideLabel">
                {inputSideLabel}
            </span>
        );

        // Datepicker options
        let datePickerOptions_formatted = func_validation.isObjectNotEmpty(datePickerOptions)?datePickerOptions:{};

        // Error Values
        let isError = false;
        let errorMsg = "";
        
        // Error Checking (Default)
        isError = (isFormSubmissionAttempted && !inputValue);
        errorMsg = (func_validation.isStringTrimNotEmpty(customErrorMsgDefault))?customErrorMsgDefault:"Input is Required";
        
        // Custom Error Checking (Empty)
        if (func_validation.isNotNullUndefined(customErrorValidation)) {
            isError = (customErrorValidation);
            errorMsg = (isError && func_validation.isStringTrimNotEmpty(customErrorMsg))?
                        customErrorMsg:errorMsg;
        }
        
        // Error Display
        let errorDisplay = (isError)?(<span className="component-formInput-errorMessage">{errorMsg}</span>):"";
        
        // Custom Error for Input
        let isInputHasError_formatted = func_validation.isBooleanTrueNotNullUndefined(isInputHasError);

        // Custom Error Display
        let customErrorDisplay = "";
        if (func_validation.isArrayNotEmpty(customErrorDisplayArray)) {
            customErrorDisplay = customErrorDisplayArray.map((customErrorDisplayItem, idx)=>{
                let isError_custom = func_validation.getObjectPropertyValue(customErrorDisplayItem, "isError", false);
                let errorMsg_custom = func_validation.getObjectPropertyValue(customErrorDisplayItem, "errorMsg", "");
                if (func_validation.isBooleanTrueNotNullUndefined(isError_custom) && 
                    func_validation.isStringTrimNotEmpty(errorMsg_custom)) {
                    return (<span className="component-formInput-errorMessage" key={idx}>{errorMsg_custom}</span>);
                }
            });
        }
        
        // Input Options
        let inputCustomOptions_formatted = (func_validation.isObjectNotEmpty(inputCustomOptions)?inputCustomOptions:{});
        
        return (
            <FormInput className={""+((className)?className+" ":"")+
                                       ((formInputCustomTheme)?formInputCustomTheme+" ":"component-formInputTheme_default ")} 
                isMarginBtmOptional={isMarginBtmOptional}>
                
                <div className="component-formInputDate">

                    {/* Label */}
                    {(isLabelOptional)?"":(
                        (inputSideLabel)?(
                            <div className="component-formInput-labelGroup d-flex align-items-center justify-content-between">
                                {inputLabelDisplay}
                                {inputSideLabelDisplay}
                            </div>
                        ):inputLabelDisplay
                    )}
                    
                    {/* Input */}
                    <DatePicker 
                        className={"component-formInput-input "+
                                    ((customInputClassName)?customInputClassName+" ":"")+
                                    (((isError || isInputHasError_formatted) && !isErrorOptional)?"component-formInput-inputHasError ":"")} 
                        selected={datePickerDateStore} dateFormat={dateFormat}
                        
                        onChange={(date)=>{ this.handleInputChange(date); }}
                        onFocus={(e)=>{ if (isInputFocusHandlingRequired) this.handleInputFocus(e); }}
                        onBlur={(e)=>{ if (isInputBlurHandlingRequired) this.handleInputBlur(e); }} 

                        {...datePickerOptions_formatted} 
                        
                        placeholderText={(inputPlaceholder)?inputPlaceholder:""} 
                        disabled={(isInputDisabled)} 
                        
                        {...inputCustomOptions_formatted}
                    />
                    
                    {/* Error Message */}
                    {(isErrorOptional)?"":(errorDisplay)}
                    
                    {/* Custom Error Message */}
                    {(customErrorDisplay)?customErrorDisplay:""}
                    
                </div>
            </FormInput>
        );
    }
}



const FormInput_date = FormInput_datePresentation;
export { FormInput_date };